import { mapGetters, mapActions } from 'vuex';
import eventBus from '@/utilities/EventBus';

export default {
  computed: {
    ...mapGetters({
      mobileTopBarContent: 'mobileTopBar/mobileTopBarContent',
      hasMobileTopBarContent: 'mobileTopBar/hasMobileTopBarContent',
      getMobileTopBarSchema: 'mobileTopBar/getMobileTopBarSchema',
      topBarToRestoreTo: 'mobileTopBar/topBarToRestoreTo',
      isMobileTopBarOrigin: 'mobileTopBar/isMobileTopBarOrigin',
      mobileMenuOpened: 'mobileTopBar/mobileMenuOpened',
    }),
  },
  methods: {
    ...mapActions({
      updateMobileTopBarContent: 'mobileTopBar/updateMobileTopBarContent',
      clearMobileTopBarContent: 'mobileTopBar/clearMobileTopBarContent',
      setTopBarToRestoreTo: 'mobileTopBar/setTopBarToRestoreTo',
    }),
    showSpecificMobileTopBar({ origin = '', topBarProperties = {} }) {
      const topBarToShow = this.getMobileTopBarSchema(origin);

      if (topBarToShow) {
        const properties = {
          ...topBarToShow,
          ...topBarProperties,
        };

        // allow a top bar to be shown after an existing top bar is exited
        // if navigationMenu is going to be shown, retain the current origin
        // else keep note of where this incoming top bar is comingFrom
        let restoringTo = '';

        if (topBarToShow.navigationMenu) {
          if (this.mobileTopBarContent.restoreOriginFromNav) {
            // useful for linking top bars that can originate from the nav menu or elsewhere
            restoringTo = this.mobileTopBarContent.restoreOriginFromNav;
          } else {
            restoringTo = this.mobileTopBarContent.origin;
          }
        } else {
          restoringTo = properties.comingFrom;
        }

        this.setTopBarToRestoreTo(restoringTo);

        // update the top bar content
        this.updateMobileTopBarContent(properties);
      }
    },
    emitMobileTopBarAction({
      action = '',
      goTowards = '',
    }) {
      if (action) {
        // emit to any listener for an action to be performed
        // restore will bring the top bar back to the previous one or a specified one
        eventBus.$emit('acv::mobile-top-bar-action', {
          action,
          topBarToRestoreTo:
            action === 'restore'
              ? goTowards || this.topBarToRestoreTo
              : undefined,
        });
      }
    },
    teardownMobileTopBar() {
      this.clearMobileTopBarContent();
      this.setTopBarToRestoreTo('');
    },
  },
};
